import { Component, computed, HostBinding, input } from '@angular/core';

@Component({
  selector: 'app-tag-status',
  styles: [':host { display: contents; }'],
  template: `
    <div [class]="statusClass() + ' flex justify-center items-center gap-1 whitespace-nowrap shrink-0'">
      <i [class]="iconClass! + ' text-xl'"></i>
      {{ text() }}
    </div>
  `,
})
export class TagStatusComponent {
  status = input<number | string>(1);
  text = input<string>('');
  iconClass = 'ph ph-info';

  statusClass = computed(() => {
    if (typeof this.status() === 'string') {
      switch (this.status()) {
        case 'Draft':
          return 'tag-info';

        case 'Active':
        case 'Approved':
        case 'Confirmed':
        case 'Shipped':
        case 'Delivered':
          this.iconClass = 'ph ph-check-circle';
          return 'tag-success';

        case 'Inactive':
        case 'Deactivated':
          return 'tag-disabled';

        case 'Locked':
        case 'Pending':
        case 'InProgress':
        case 'PaymentPending':
        case 'ContractPending':
        case 'DocumentsPending':
        case 'Reserved':
          this.iconClass = 'ph ph-warning';
          return 'tag-warning';

        case 'Rejected':
        case 'Cancelled':
          this.iconClass = 'ph ph-x-circle';
          return 'tag-error';

        default:
          return 'tag-info';
      }
    } else {
      switch (this.status()) {
        case 1:
          return 'tag-info';
        case 2:
          return 'tag-success';
        case 3:
          return 'tag-disabled';
        case 12:
          this.iconClass = 'ph ph-warning';
          return 'tag-warning';
        default:
          return 'tag-info';
      }
    }
  });
}
